export const FilterLineIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '17'}
    height={props?.height || '12'}
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33496 5.83594H13.335M0.834961 0.835938H15.835M5.83496 10.8359H10.835"
      stroke={props?.color || '#3966E0'}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
